///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { WindeAppModule } from './app.module';
import { ENABLE_PROD_MODE } from '../environments/environment';
import { enableProdMode } from '@angular/core';

if (ENABLE_PROD_MODE) {
    enableProdMode();
}

platformBrowserDynamic()
    .bootstrapModule(WindeAppModule, { preserveWhitespaces: false })
    .then((_success) => console.log(`Application started`))
    .catch((err) => console.error(err));
